import { zodResolver } from '@hookform/resolvers/zod';
import { FileInput } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons-react';
import { type DefaultValues, type FieldValues, type Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { useFieldErrorText } from './errors.js';

/**
 * RHF + Zod (CLAUDE.md "Form ve doğrulama"): formun değerleri girdinin biçimidir (boş tarih ve
 * kimlik `null`, boş metin `''`); gönderimde aynı şemanın çıktısı (sunucuyla ortak, `@felix/domain`).
 */
export function useSchemaForm<Values extends FieldValues>(
  schema: z.ZodType,
  defaultValues: Values,
) {
  return useForm<Values>({
    resolver: zodResolver(schema as never) as unknown as Resolver<Values>,
    defaultValues: defaultValues as DefaultValues<Values>,
    mode: 'onSubmit',
  });
}

/** Alan hatasının metni: `formState.errors[ad].message` kodu. */
export function useErrorOf() {
  const text = useFieldErrorText();
  return (errors: Record<string, { message?: unknown } | undefined>, name: string) => {
    const message = errors[name]?.message;
    return typeof message === 'string' ? text(message) : undefined;
  };
}

export const SCAN_ACCEPT = 'application/pdf,image/jpeg,image/png';

/** Tarama (PDF, JPEG, PNG; isteğe bağlı): kayıttan sonra ek olarak eklenir (K15 kalıbı). */
export function ScanInput({
  label,
  value,
  onChange,
}: {
  label: string;
  value: File | null;
  onChange: (file: File | null) => void;
}) {
  const { t } = useTranslation();
  return (
    <FileInput
      label={label}
      accept={SCAN_ACCEPT}
      clearable
      value={value}
      onChange={onChange}
      placeholder={t('vesselCertificates.dialogs.import.choose')}
      leftSection={<IconPaperclip size={15} aria-hidden />}
    />
  );
}
